<template>
  <div ref="submenu" class="kbo-sidebar--submenu bg" :class="{ open: active }">
    <div @click.stop="handleToggle">
      <slot></slot>
    </div>
    <div class="items" @click="handleClose">
      <slot name="items"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "KboSidebarSubmenu",
  data() {
    return {
      active: false,
    };
  },
  created() {
    window.addEventListener("click", this.handleWindowClick, true);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleWindowClick);
  },
  methods: {
    handleWindowClick(ev) {
      if (this.active) {
        const el = this.$refs.submenu;
        const parent = ev.target.contains(el);
        if (!parent) {
          this.handleClose();
        }
      }
    },
    handleClose() {
      this.active = false;
    },
    handleToggle() {
      this.active = !this.active;
    },
  },
};
</script>

<style>
.kbo-sidebar--submenu .items .close {
  height: 40px !important;
  width: 40px !important;
  right: -38px !important;
}
</style>

<style lang="scss" scoped>
.kbo-sidebar--submenu {
  position: relative;
  .items {
    position: absolute;
    overflow-y: auto;
    max-height: 100vh;
    top: -36px;
    left: 54px;
    opacity: 0;
    padding-top: 40px;
    padding-left: 4px;
    padding-bottom: 40px;
    padding-right: 70px;
    transition:
      opacity 0.2s ease-in-out,
      transform 0.2s ease-in-out;
    transform: scale(0);
    transform-origin: left 50px;
    min-width: 300px;
  }

  &.open {
    .items {
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
